export const ACTIVE_TAB_STORAGE_KEY = 'muzone_active_tab';
export const NAVIGATE_TAB_EVENT = 'muzone:navigate-tab';
